import { useParams } from "react-router-dom";
import CardGrid from "../components/CardGrid";
import { packages } from "../data/packages";
import "./PackageCategory.css"; // add this

export default function PackageCategory() {
  const { category } = useParams();
  const items = packages[category] || [];
  const itemsWithCategory = items.map(item => ({ ...item, category }));

  return (
    <section className="section">
      <h2 className="package-category-title">
        {category.replace("-", " ").toUpperCase()} Packages
      </h2>
      <CardGrid items={itemsWithCategory} />
    </section>
  );
}
